import React from 'react';


import * as addressConstants from '../addressConstants';

import styles from './Address.scss';


function Address({address}) {

    // const renderLine = (...values) => {
    //
    //     const value = values.join(' ');
    //     if (!value) {
    //
    //         return null;
    //     }
    //
    //     return (
    //         <>
    //             {values}<br/>
    //         </>
    //     );
    // };

    return (
        <div className={styles.address}>
            <span className={styles.name}>
                {address.name}<br />
                {address.nameAddition}
            </span>
            <span className={styles.location}>
                {address.addressLine1}<br/>
                {address.addressLine2}<br />
                {address.postCode} {address.city}<br />
                {address.state}<br />
                {address.countryNativeName}
            </span>
        </div>
    );
}


Address.propTypes = {
    address: addressConstants.SHAPE_ADDRESS.isRequired
};

Address.defaultProps = {};


export default Address;
